import React from 'react';
import css from './css.module.less';
import Button from 'src/components/CloneButton';
import ErrorProcessingComponent from '@/src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC/ErrorProcessingComponent';
import { DragNDrop } from '@/src/components';
import { useDispatch, useSelector } from 'react-redux';
import {
  // getImageCarouselSetting,
  // onImageCarouselSettingChange,
  getImageCollapseOpenStatus,
  getImageCollapseValidationMsgDisplay,
  onImageCollapseOpen,
  onImageErrorChange,
  getImageCarouselLayer,
  onImageLayerChange,
} from 'src/constrains/ResponsiveLayerEditor/slice';
import Layer from './Layer';
import { ActionType } from 'src/types/common/common';
import { validateImageLayer } from 'src/constrains/DraggableModules/tools';
import { Icon } from '@/src/tools/icon';

const Layers = (props) => {
  const {
    linkSet,
    isConvertible,
    buttons,
    animations,
    hoverAnimations,
    onChanged,
  } = props;
  //console.log('specificError', specificError);
  const d = useDispatch();
  const data = useSelector(getImageCarouselLayer()) || [];

  const handleOnOrderOnChange = (index, target) => {
    if (onChanged) {
      onChanged();
    }
    d(
      onImageLayerChange({
        type: ActionType.reorder,
        from: index,
        to: target,
      }),
    );
  };

  const handleOnChange = (index, target) => {
    if (onChanged) {
      onChanged();
    }
    d(
      onImageLayerChange({
        type: ActionType.modify,
        index,
        target,
      }),
    );
  };

  const handleOnMenuAdd = () => {
    if (onChanged) {
      onChanged();
    }
    d(
      onImageLayerChange({
        type: ActionType.add,
      }),
    );
  };

  // const handleOnVisibleChange=()=>{}

  const disabledAdd = data.length >= 5 || isConvertible; //isImage &&

  const renderChild = (layer, provided, index) => {
    const { visible } = layer;
    return (
      <ErrorProcessingComponent
        data={layer}
        key={layer.draggableId}
        id={layer.draggableId}
        title={
          <div className={css.titleContainer}>
            {visible ? (
              <Icon
                type='iconvisible'
                className={css.visible}
                onClick={(e) => {
                  if (onChanged) {
                    onChanged();
                  }
                  e.stopPropagation();
                  e.preventDefault();
                  handleOnOrderOnChange(index, { visible: false });
                }}
              />
            ) : (
              <Icon
                onClick={(e) => {
                  if (onChanged) {
                    onChanged();
                  }
                  e.stopPropagation();
                  e.preventDefault();
                  handleOnOrderOnChange(index, { visible: true });
                }}
                type='iconinvisible'
                className={css.inVisible}
              />
            )}

            {`Layer ${index + 1}`}
          </div>
        }
        collapseProps={{
          titleContainerClassName: isConvertible ? '' : css.dragContainer,
          collapseComponentTitleProps: {
            ...provided.dragHandleProps,
            // style: {
            //   boxShadow: '-4px 0px 0px 0px rgba(0,0,0,1)',
            //   // backgroundColor: 'red'
            // },
          },
        }}
        validation={(x, _p) => {
          const { breakpoint } = _p;
          return validateImageLayer(x, breakpoint);
        }}
        getErrorDisplay={getImageCollapseValidationMsgDisplay}
        onErrorChange={onImageErrorChange}
        getCollapseOpenStatus={getImageCollapseOpenStatus}
        onCollapseOpen={onImageCollapseOpen}
        headerProps={{
          dotsFunction: [
            ...(isConvertible
              ? []
              : [
                  {
                    key: 'Delete',
                    body: 'Delete',
                    isDangerous: true,
                    displayWarningModal: true,
                    onClick: () => void 0,
                    modalOnOk: () => {
                      const id = layer.draggableId;
                      if (onChanged) {
                        onChanged();
                      }
                      d(
                        onImageLayerChange({
                          type: ActionType.delete,
                          draggableId: id,
                          index,
                        }),
                      );
                    },
                    modalTitle: 'Delete Layer',
                    modalContent: 'Are you sure to delete the layer ?',
                  },
                ]),
          ],
          hasDots: !isConvertible,
        }}
        renderComponent={(error) => {
          const { specificError, display } = error;
          return (
            <Layer
              displayError={display}
              isConvertible={isConvertible}
              linkSet={linkSet}
              specificError={specificError}
              data={layer}
              animations={animations}
              hoverAnimations={hoverAnimations}
              buttons={buttons}
              onChange={(target) => {
                if (onChanged) {
                  onChanged();
                }
                handleOnChange(index, target);
              }}
            />
          );
        }}
      />
    );
  };
  return (
    <React.Fragment>
      {!disabledAdd && (
        <Button
          disabled={disabledAdd}
          buttonText={'+ Add Layer'}
          onClick={handleOnMenuAdd}
          avoidAlert
        />
      )}

      <DragNDrop
        disableAllDrags={isConvertible}
        droppableId={'SalesChannelContentListImageDraggableLayer'}
        //disableAllDrags={disabled}
        list={data}
        childGenerator={renderChild}
        onChange={handleOnOrderOnChange}
      />
    </React.Fragment>
  );
};

export default Layers;
